import { gql, TypedDocumentNode } from "@apollo/client";

import { AuthorizationScheme } from "types/generated";

type GetPersonalSettingsData = {
  authorizationScheme: AuthorizationScheme;
  apiKeysManagedByNonRootAdmins?: boolean;
};

type GetPersonalSettingsVariables = {
  skipApiKeysManagedByNonRootAdminsField?: boolean;
};

export const GET_PERSONAL_SETTINGS: TypedDocumentNode<
  GetPersonalSettingsData,
  GetPersonalSettingsVariables
> = gql`
  query GetPersonalSettings($skipApiKeysManagedByNonRootAdminsField: Boolean = false) {
    authorizationScheme
    apiKeysManagedByNonRootAdmins @skip(if: $skipApiKeysManagedByNonRootAdminsField)
  }
`;
